import { render, staticRenderFns } from "./buttonTempl.vue?vue&type=template&id=158c83dc"
import script from "./buttonTempl.vue?vue&type=script&lang=js"
export * from "./buttonTempl.vue?vue&type=script&lang=js"
import style0 from "./buttonTempl.vue?vue&type=style&index=0&id=158c83dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports